import React from 'react';
import { useI18n } from '../i18n';
import WaitlistForm from '../components/WaitlistForm';
import SocialLinks from '../components/SocialLinks';

const ProgramarVisita = () => {
  const { t, content } = useI18n();
  const book = content.book;
  return (
    <main data-testid="book-page">
      <section className="pt-36 lg:pt-44 pb-16 lg:pb-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <div className="overline mb-6">{book.eyebrow}</div>
          <h1 className="display-xl text-cyan-vidat max-w-4xl">{book.title}</h1>
          <span className="section-rule mt-10"></span>
          <div className="mt-10 max-w-2xl prose-vidat">
            <p>{book.p1}</p>
            <p>{book.p2}</p>
          </div>
        </div>
      </section>

      <section className="bg-ivory py-20 lg:py-28" data-testid="book-form-section">
        <div className="max-w-[1000px] mx-auto px-6 lg:px-12">
          <div className="text-[11px] uppercase tracking-[0.28em] text-cyan-vidat font-medium mb-6">
            {t('form.submit')}
          </div>
          <h2 className="display-md text-cyan-vidat max-w-2xl mb-10">
            {content.location.notify}
          </h2>
          <WaitlistForm testIdPrefix="book-waitlist" />
          <div className="mt-14 pt-8 border-t border-stone-200 flex flex-wrap items-center gap-6">
            <span className="text-[11px] uppercase tracking-[0.22em] text-stone-500">
              {t('footer.follow')}
            </span>
            <SocialLinks variant="light" testIdPrefix="book-waitlist-social" />
          </div>
        </div>
      </section>

    </main>
  );
};

export default ProgramarVisita;
